import TemplateComponentController from '../template_component_controller'

export default class extends TemplateComponentController {
  protected logPrefix = '[CreditCardFormSetup]'
}
